import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import VendorHome from './tabs/home/VendorHome';
import VendorLocations from './tabs/locations/VendorLocations';
import VendorProfile from './tabs/profile/VendorProfile';
import VendorPromotions from './tabs/promotions/VendorPromotions';
import VendorReferrals from './tabs/referrals/VendorReferrals';
import CarrierLookup from '../partners/tabs/carrier-lookup/CarrierLookup';

interface VendorDashboardProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
  showSideNav: boolean;
  setShowSideNav: (show: boolean) => void;
}

function VendorDashboard({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
  showSideNav,
  setShowSideNav,
}: VendorDashboardProps) {
  const [currSubPage, setCurrSubPage] = useState<string | null>(null);
  const handleSetSubPage = (page: string | null) => {
    setCurrSubPage(page);
  };
  const commonProps = {
    userType,
    currentPage,
    currentTab,
    setCurrentTab,
    subTab,
    setSubTab,
    currSubPage,
    setCurrSubPage: handleSetSubPage,
  };

  return (
    <Routes>
      <Route path="/" element={<VendorHome {...commonProps} />} />
      <Route path="home" element={<VendorHome {...commonProps} />} />
      <Route
        path="locations/*"
        element={<VendorLocations {...commonProps} />}
      />
      <Route
        path="promotions/*"
        element={<VendorPromotions {...commonProps} />}
      />
      <Route path="profile/*" element={<VendorProfile {...commonProps} />} />
      <Route
        path="referrals/*"
        element={<VendorReferrals {...commonProps} />}
      />
      <Route
        path="carrier-lookup/*"
        element={<CarrierLookup {...commonProps} />}
      />
    </Routes>
  );
}

export default VendorDashboard;
